@import '~style-sheet-helpers/core.less';
@import '../../constants/spacing.module.less';

.strategy-and-tag {
  display: flex;
  align-items: center;
  gap: @space-8;
}

.strategy-default-tag {
  display: flex;
  align-items: center;
  background-color: var(--grey-200);
  border-radius: 4px;
  padding: @space-4 @space-8;
  font-size: 12px;
  max-height: 24px;
}
